import Cookies from 'js-cookie';
var TokenKey = 'package_token';
export function getToken() {
  return Cookies.get(TokenKey);
  // return sessionStorage.getItem(TokenKey)
}
export function setToken(token) {
  // sessionStorage.setItem(TokenKey, token)
  Cookies.set(TokenKey, token, {
    expires: 1
  });
}
export function removeToken() {
  sessionStorage.removeItem(TokenKey);
  Cookies.remove(TokenKey);
}
export function getConfirmJobLevel() {
  return Cookies.get('confirmJobLevel');
}
export function setConfirmJobLevel(wait_confim_job_level) {
  Cookies.set('confirmJobLevel', wait_confim_job_level, {
    expires: 1
  });
}
export function removeConfirmJobLevel() {
  Cookies.remove('confirmJobLevel');
}